/* PDP v2 决策区滚动浮现（多 section 共享，防重复初始化） */
(function () {
  if (window.__pdp2MotionInit) { window.__pdp2Scan && window.__pdp2Scan(); return; }
  window.__pdp2MotionInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.documentElement.classList.add('pdp2-js');

  var io = null;
  if (!reduce && 'IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('pdp2-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
  }

  function scan() {
    document.querySelectorAll('.pdp2-reveal:not(.pdp2-in), .pdp2-stagger:not(.pdp2-in)').forEach(function (el) {
      if (!io) { el.classList.add('pdp2-in'); return; }
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight) { el.classList.add('pdp2-in'); }
      else { io.observe(el); }
    });
  }
  window.__pdp2Scan = scan;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else { scan(); }

  /* 主题编辑器里增删 section 后重新扫描 */
  document.addEventListener('shopify:section:load', scan);
})();
